import { defineComponent as _defineComponent } from 'vue'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'UIActionButton'
})

import ZIcon from '~/components/zeal/ZIcon/ZIcon.vue'

interface Props {
  icon: string
  label: string
  variant?: 'primary' | 'destructive'
  loading?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    icon: null,
    label: null,
    variant: { default: 'primary' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props as { icon: string, label: string, variant: 'primary' | 'destructive', loading: boolean, disabled: boolean };





const variantClasses = {
  primary: 'bg-gray-1 text-gray-12 hover:bg-gray-3',
  destructive: 'bg-cherry-500/10 text-cherry hover:bg-cherry-500/20'
}

return { __sfc: true,props, variantClasses, ZIcon }
}

})